/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from "lodash";
import Modal from 'react-responsive-modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import CountUp from 'react-countup';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import { getDDMMYYYY, getDDMMYYYYHHMMSS, getHyphenDDMMMYYYYHHMM } from '../common/utils';
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CSVFileValidator from 'csv-file-validator';
import more from 'material-ui/svg-icons/notification/more';
import $ from 'jquery';
//import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
var redirectURL = require('../redirectURL');
var moment = require('moment');

export default class CreditMaster extends Component {
    state = {
        show: false,
        basicTitle: '',
        basicType: "default",
        loadshow: "show-n",
        overly: "show-n",
        rowData: [],
        pivotmodeis: false,
        pivotcols: [],
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true

        },
        frameworkComponents: {
        },
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
        animateRows: true,
        debug: true,
        showToolPanel: true,
        suppressAggFuncInHeader: true,
        statusBar: {
            statusPanels: [
                {
                    statusPanel: "agTotalAndFilteredRowCountComponent",
                    align: "left"
                },
                {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center"
                },
                { statusPanel: "agFilteredRowCountComponent" },
                { statusPanel: "agSelectedRowCountComponent" },
                { statusPanel: "agAggregationComponent" }
            ]
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel"
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }
            ]
        },
        csvcontent: [],
        file: '',
        slider: 'show-n'
    }

    componentDidMount() {
        this.loadData()
    }

    loadData = () => {
        redirectURL.post("/masters/getCreditMaster", {},{
			headers: {
				'Content-Type': 'application/json',
				'Authorization': localStorage.getItem("userid")
			  }
		  }).then(res => {
            let respData = res.data
            console.log("respData",respData)
            this.setState({
                rowData: respData.creditMaster,
            })
            // console.log("resData", respData)
        })
    }
    closeAlert = () => {
        this.setState({
            show: false,
            basicType: "",
            basicTitle: ""
        })
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };

    onGridState = () => {
        //console.log(this.gridApi);
        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();
        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();
        /*Get Current Pivot Columns State and Store in this.pivotColumns,
         * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();
        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }

    changeCreditHandler = async (e) => {
        if(e.target.files.length !== 0){
            const config = {
                headers: [
                  
                    {
                        name: 'consignee_name',
                        inputName: 'consignee_name',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'consignee_code',
                        inputName: 'consignee_code',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },
                    {
                        name: 'credit_type',
                        inputName: 'credit_type',
                        required: true,
                        requiredError: function (headerName, rowNumber, columnNumber) {
                            return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                        }
                    },     
                    // {
                    //     name: 'consignee_city',
                    //     inputName: 'consignee_city',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // },
                    // {
                    //     name: 'zone',
                    //     inputName: 'zone',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // },  
                    // {
                    //     name: 'transit_time',
                    //     inputName: 'transit_time',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // },    
                    // {
                    //     name: 'service_provider',
                    //     inputName: 'service_provider',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // },
                    // {
                    //     name: 'vehicle_mode',
                    //     inputName: 'vehicle_mode',
                    //     required: true,
                    //     requiredError: function (headerName, rowNumber, columnNumber) {
                    //         return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    //     }
                    // },          
                ]
            }
            const aplhanumeichypen = new RegExp(/^[a-zA-Z0-9- ._,&#]*$/); // define allowed characters using regex
            
            var data = CSVFileValidator(e.target.files[0], config)
                .then((csvData) => {
                    console.log('csvData', csvData)
                    // if (csvData.inValidMessages.length > 0) {
                    //     $("#uploadFile").val("")
                    //     this.setState({
                    //         show: true,
                    //         basicTitle: 'dont upload other fields',
                    //         basicType: 'danger'
                    //     });
                    // } else {
                    //     this.setState({
                    //         csvcontent: csvData.data
                    //     });
                    // }
                    let keys = Object.keys(csvData.data[0])
                    let items = ['credit_type', 'consignee_code','consignee_name']
                    let check = false
                    for (let i in keys){
                        if(items.includes(keys[i])){    
                            check = true             
                        }else{
                            check = false
                            break
                        }
                    }
                    let csvalues = Object.values(csvData.data[0])
                    if(csvalues.length > 0)
                    {
                        for(let c in csvalues)
                        {
                            // console.log("csvalues value ",csvalues[c])
                            // console.log("aplhanumeichypen",aplhanumeichypen.test(csvalues[c])+"  "+csvalues[c])
                            if(aplhanumeichypen.test(csvalues[c]) === false)
                            {
                                check = false;
                                break;
                            }
                        }
                    }
                    // console.log("check", check)
                    if (check === false) {
                        $("#uploadFile").val("")
                        // document.getElementById("appednCSVData").innerHTML = ''
                        this.setState({
                            show: true,
                            basicTitle: 'dont upload other fields',
                            basicType: 'danger'
                        });
                    } else {
                        this.setState({
                            csvcontent: csvData.data
                        });
                    }
                })
                .catch(err => { })
            // console.log("e.target.files[0]",e.target.result);
            var contentList = []
    
            var out = new Promise(function (reject, resolve) {
                var reader = new FileReader();
                reader.onload = async function (e) {
                    var contents = await e.target.result;
                    // document.getElementById("appednCSVData").innerHTML = contents
                    resolve(contents);
                };
                var tt = reader.readAsText(e.target.files[0]);
            });
            // console.log(contentList);
            this.setState({
                file: e.target.files[0]
            });
            // console.log("e.target.files[0].type ", e.target.files[0]);
    
            if (e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))
    
            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    file: "",
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
    }

    uploadBulkFormHandler = e => {
        e.preventDefault()
        const { csvcontent } = this.state
        // console.log("csvcontent", csvcontent)
        redirectURL.post("/masters/uploadCreditMastersData", csvcontent).then(res => {
            console.log("response", res)
            if (res.data.message === 'success') {
                this.setState({
                    slider: "show-n",
                    csvcontent: [],
                    file: '',
                    overly: "show-n",
                    loadshow: 'show-n'
                }, () => this.loadData())
                
            }
        })

    }

    bulkUploadTptMaster = () => {
        this.setState({
            slider: 'slider-translate-40p',
            overly: "show-m",
            loadshow: 'show-m'
        })
    }
    resetUpload = () => {
        // document.getElementById("appednCSVData").innerHTML = ''
        $("#uploadFile").val("")
        // this.setState({
        //     slider: 'show-n',
        //     overly: "show-n",
        //     loadshow: 'show-n'
        // })
    }   

    onClickHideAll = () => {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            slider: "",
        });
    }
    onCellClicked = (e) => {
        if (e.colDef.field == "delete") {
            var rowId = e.data._id;
            // console.log("delete",e.data);
            var qry = {
                rowId: rowId,
                collection : 'master_credit',
                email : localStorage.getItem('email')
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/masters/deleteRowData", qry,{
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("userid")
                      }
                  }).then((response) => {
                    // console.log("response",response);
                    if (response.data.status == "success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                        //window.location.reload();
                        setTimeout(() =>{
                            this.loadData()
                        }, 1000)
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
    }

    render() {
        const { show, basicType, basicTitle, rowData, modules, defaultColDef, statusBar, slider, loadshow, overly } = this.state
        const plantsColumnDefs = [
            // {
            //     headerName: "Plant Name",
            //     field: "plant_name",
            //     width: 150,
            //     filter: "agSetColumnFilter",
            //     resizable: true,
            // },
            // {
            //     headerName: "Plant Code",
            //     field: "plant_code",
            //     width: 130,
            //     filter: "agSetColumnFilter",
            //     resizable: true,
            // },
            {
                headerName: "Customer Name",
                field: "consignee_name",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Customer Code",
                field: "consignee_code",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                headerName: "Credit Type",
                field: "credit_type",
                width: 130,
                filter: "agSetColumnFilter",
                resizable: true,
            },
            {
                pinned: "left",
                headerName: "",
                field: "delete",
                width: 50,
                resizable: true,
                editable: false,
                cellRenderer: params => {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                filter: false,
            }   
              
        ]

        return (
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>
                <div className='row'>
                    <div className="card col-xl-12 col-lg-12">
                        <div className="card-header" style={{ padding: '10px' }}>
                            <h4>Credit Master</h4>
                            <div className="row">
                                <div className="col-sm-12">
                                    <button className="float-right btn btn-warning" onClick={this.bulkUploadTptMaster}>
                                        Bulk Upload
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="height-equal equal-height-lg" style={{ padding: '10px' }}>
                            <div className="card-body" style={{ padding: '10px' }}>
                                <div id="myGrid" style={{ height: "400px" }} className="ag-theme-balham">
                                    <AgGridReact
                                        modules={modules}
                                        columnDefs={plantsColumnDefs}
                                        defaultColDef={defaultColDef}
                                        rowData={rowData}
                                        enableCharts={false}
                                        enableRangeSelection={true}
                                        statusBar={statusBar}
                                        pagination={true}
                                        groupHeaderHeight={40}
                                        headerHeight={40}
                                        floatingFiltersHeight={50}
                                        pivotGroupHeaderHeight={30}
                                        pivotHeaderHeight={50}
                                        rowHeight={40}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        onCellClicked={this.onCellClicked}
                                    //sideBar={sideBar}
                                    // onCellDoubleClicked={this.onShowSidebarAquireComponent.bind(this)}
                                    />
                                </div>

                            </div>

                        </div>
                        <div className={"dataLoadpage " + (loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (loadshow)}>
                            <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (overly)} onClick={this.onClickHideAll}></div>


                    </div>
                        {/* tpt bulk upload  */}
                        <div className={"slide-r " + (slider)} style={{ overflow: "hidden" }}>
                            <h4 className="subH">Bulk Upload Transit Data
                            <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={this.onClickHideAll} >X</span>
                            </h4>
                            <div className="slide-r-body" style={{ position: "relative" }}>
                                <div className="container-fluid">
                                    <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>
                                        <div className="form-group mt-20p">
                                            <label className="">Upload File</label>
                                            <input type="file" id="uploadFile" name="uploadFile" onChange={this.changeCreditHandler} className="form-control" required />
                                        </div>
                                        {/* <div className='p-2' id="appednCSVData"></div> */}
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-success">Submit</button>
                                            <button type="button" onClick={this.resetUpload} className="btn btn-default">Cancel</button>
                                        </div>
                                    </form>
                                    {/* <p className='pl-3' style={{ color: 'red' }}> please format the dates in yyyy-mm-dd hh:mm:ss or dd-mm-yyyy hh:mm:ss before uploading</p> */}
                                    <div className="form-group">
                                        <a className="btn btn-primary" href={require('../../assets/json/bulk_credit_transit.csv')} target="_blank">Sample Template</a>

                                    </div>
                                </div>
                            </div>
                        </div>
                </div>

            </div>
        )
    }
}